import cn from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

const Table = ({ whiteTable = true, minWidth, minHeight, ...props }) => {
  return (
    <div
      className={cn(styles.table, whiteTable && styles.white_table, props.styles)}
      style={{ minWidth, minHeight, ...props.style }}
    >
      {props.children}
    </div>
  );
};

export default Table;
